module.exports = {
  "country": "LT",
  "artist": "The Roop",
  "song": "On Fire",
  "year": "2020",
  "place": "NQ",
  "spotify": "1K9p7bRwepINjSWKBxR3HA"
};